// @ts-nocheck
import Axios from 'axios'
import { URL, ErrorCode } from './const'
import { setUserRoles, convertToDate, showAlert } from './utils/business';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import * as GlobalFunc from './utils/globalFunc';

export const FILE_REPORT_TYPE = {
    DOCX: 'docx',
    PDF: 'pdf',
    XLSX: 'xlsx'
}

let RoleGroup = null
let token = null
let userInfo = null

export function calculate(reportDate, reportName, singleConsol, scenario, isIcaap) {
    return post({
        url: isIcaap ? `${URL.calculatorV2}/icaap` : `${URL.calculatorV2}/car`,
        data: {
            report_date: reportDate,
            report_name: reportName,
            single_consol: singleConsol,
            scenario: scenario
        }
    }).then(res => {
        return res;
    })
}

export function getVersion() {
    return get({
        url: URL.versionV2
    }).then(res => {
        return res
    })
}

export function updateNameAndReportDate(data) {
    return post({
        url: `${URL.uploadManagementV2}/update-name-and-report-date`,
        data,
        contentType: 'application/json'
    }).then(res => {
        return res
    })
}

export function getBatCalculating() {
    return get({
        url: `${URL.uploadManagementV2}/status/calculating`,
    }).then(res => {
        return res
    })
}


export function uploadChuckFile(chuck, params) {
    return post({
        url: `${URL.fileV2}/upload-chunks`,
        data: chuck,
        params: params,
        contentType: 'application/json'
    }).then(res => {
        return res
    })
}

export function uploadChuckFileComplete(fileName, params, isIcaap) {
    let formData = new FormData();
    formData.append('fileName', fileName);

    return post({
        url: isIcaap ? `${URL.fileV2}/upload-icaap-complete` : `${URL.fileV2}/upload-complete`,
        data: formData,
        params: params,
        contentType: 'multipart/form-data'
    }).then(res => {
        return res
    })
}

export function uploadCapitalChunkFileComplete(fileName, params) {
    let formData = new FormData();
    formData.append('fileName', fileName);

    return post({
        url: `${URL.fileV2}/upload-capital-complete`,
        data: formData,
        params: params,
        contentType: 'multipart/form-data'
    }).then(res => {
        return res
    })
}

export function getListScenarios(reportDate, reportName) {
    return get({
        url: `${URL.uploadManagementV2}/icaap/scenarios?report_date=${reportDate}&report_name=${reportName}`
    }).then(res => {
        return res
    })
}

export function getBatchResult(reportDate, reportName) {
    return get({
        url: `${URL.fileV2}/batch-result?report_date=${reportDate}&report_name=${reportName}`
    }).then(res => {
        return res
    })
}

export function downloadFileReportWithType(fileName, reportDate, reportName, type, component, fileType) {
    const url = getLinkDownLoadXLSX(fileName, reportDate, reportName, type, component);
    const fileNameExport = (fileName + '').replace(".xlsx", `.${fileType}`)
    if (fileType === FILE_REPORT_TYPE.DOCX || fileType === FILE_REPORT_TYPE.PDF) {
        return post({
            url: `${URL.downloadReportType}`,
            responseType: 'blob',
            data: {
                type: fileType,
                url: url
            }
        }).then(res => {
            console.log(res);
            if (!res || res.type === 'application/json') {
                return showAlert({
                    title: 'Error',
                    content: 'Download failed'
                });
            }
            return saveAs(res, `${fileNameExport}`);
        })
    } else {
        return downloadFile(fileName, reportDate, reportName, type, component)
    }
}



export function getLinkDownLoadXLSX(fileName, reportDate, reportName, type, component) {
    let url = `${URL.downloadV2}/download/${fileName}`;
    const params = {};
    if (reportDate) params['report_date'] = reportDate;
    if (reportName) params['report_name'] = reportName;
    if (type) params['type'] = type;
    if (component) params['c'] = component;
    Object.keys(params) && Object.keys(params).forEach((key, i) => { i === 0 ? url += `?${key}=${params[key]}` : url += `&${key}=${params[key]}` });
    return url
}

export function downloadFile(fileName, reportDate, reportName, type, component) {
    let url = `${URL.downloadV2}/download/${fileName}`;
    const params = {};
    if (reportDate) params['report_date'] = reportDate;
    if (reportName) params['report_name'] = reportName;
    if (type) params['type'] = type;
    if (component) params['c'] = component;
    Object.keys(params) && Object.keys(params).forEach((key, i) => { i === 0 ? url += `?${key}=${params[key]}` : url += `&${key}=${params[key]}` });

    return getWithBlob({
        url
    }).then(res => {
        if (!res || res.type === 'application/json') {
            return showAlert({
                title: 'Error',
                content: 'Download failed'
            });
        }
        return saveAs(res, `${fileName}`);
    })
}


export function makeDownloadFileInfo(fileName, reportDate, reportName, type, component) {
    // { name: "file1.xlsx", url: "https://url.com/file1.xlsx?type=input_calculation&report_date=31/12/2022&report_name=undefined" }
    let url = `${URL.downloadV2}/download/${fileName}`;
    const params = {};
    if (reportDate) params['report_date'] = reportDate;
    if (reportName) params['report_name'] = reportName;
    if (type) params['type'] = type;
    if (component) params['c'] = component;
    Object.keys(params) && Object.keys(params).forEach((key, i) => { i === 0 ? url += `?${key}=${params[key]}` : url += `&${key}=${params[key]}` });

    return {
        name: fileName,
        url,
    };
}

export function downloadFileByDownloadId(downloadId, reportDate, reportName) {
    const fileName = `${convertToDate(reportDate)}_${reportName}.zip`
    return getWithBlob({
        url: `${URL.downloadV2}/download?download_id=${downloadId}`
    }).then(res => {
        if (!res || res.type === 'application/json') {
            // return showAlert({
            //     title: 'Error',
            //     content: 'Download failed'
            // });
        }
        return saveAs(res, `${fileName}`);
    })
}

export function getBatchDownload(downloadId) {
    return get({
        url: `${URL.downloadV2}/batch-download?download_id=${downloadId}`
    }).then(res => {
        return res
    })
}

export function createDownloadId(downloadId, lstFilesDownload, reportDate, reportName, type, component) {
    return post({
        url: `${URL.downloadV2}/download`,
        data: {
            download_id: downloadId,
            report_date: reportDate,
            report_name: reportName,
            files: lstFilesDownload,
            options: {
                type,
                c: component
            }
        }
    }).then(res => {
        return res;
    })
}

export async function downloadAllFiles(fileArr, reportDate, reportName) {
    const zip = new JSZip();
    const result = {
        is_error: false,
        failed_files: []
    };

    try {
        const arrOfFiles = fileArr.map((item) => {
            const config = {
                responseType: 'blob',
                headers: {
                    Authorization: "bearer " + token
                }
            }
            return Axios.get(item.url, config)
                .then((resp) => {
                    if (resp.data.type === 'application/json') {
                        return Promise.reject();
                    } else {
                        zip.file(item.name, resp.data);
                        return Promise.resolve();
                    }
                })
                .catch((err) => {
                    console.log(`Failed to download ${item.url}:`, err);
                    result.failed_files.push(item.name);  // Lưu tên file bị lỗi
                    result.is_error = true;
                    return Promise.reject();
                })
        });

        await Promise.allSettled(arrOfFiles);

        zip.generateAsync({ type: "blob" }).then(function (blob) {
            saveAs(blob, `${convertToDate(reportDate)}_${reportName}.zip`);
        });

        if (result.failed_files.length > 0) {
            console.log('Failed to download the following files:', result.failed_files);
            // alert('Some files failed to download: ' + result.failed_files.join(', '));
        }
    } catch (error) {
        console.log(error);
        result.is_error = true;
    }

    if (result.failed_files.length > 30) {
        result.failed_files = result.failed_files.slice(0, 30);
        result.failed_files.push('...');
    }

    return result;
}

export function downloadSampleFile(fileName, type, component) {
    let url = `${URL.downloadV2}/download/${fileName}`;
    const params = {};
    if (type) params['type'] = type;
    if (component) params['c'] = component;
    Object.keys(params) && Object.keys(params).forEach((key, i) => { i === 0 ? url += `?${key}=${params[key]}` : url += `&${key}=${params[key]}` });

    return saveAs(`${url}`, fileName);
}

export function getListBatch(component, objSearch) {
    const { report_date, report_name, file_name, company, upload_time, approval_by } = (objSearch || {});
    let subQuery = '';
    if (report_date) subQuery += `report_date=${report_date}&`;
    if (report_name) subQuery += `report_name=${report_name}&`;
    if (upload_time) subQuery += `upload_time=${upload_time}&`;
    if (company) subQuery += `company=${company}&`;
    if (file_name) subQuery += `file_name=${file_name}&`;
    if (approval_by) subQuery += `approval_by=${approval_by}&`;

    return get({
        url: `${URL.batchV2}/${component}${subQuery ? `?${subQuery}` : ''}`
    }).then(res => {
        return res
    })
}

export function deleteBatch(component, fileName) {
    return del({
        url: `${URL.batchV2}/${component}?file_name=${fileName}`,
        data: { file_name: fileName }
    }).then(res => {
        return res
    })
}

export function getUploadManagement(component, objSearch) {
    const { report_date, file_name, upload_by, approval_by } = (objSearch || {});
    let subQuery = '';
    if (report_date) subQuery += `report_date=${report_date}&`;
    if (file_name) subQuery += `file_name=${file_name}&`;
    if (upload_by) subQuery += `upload_by=${upload_by}&`;
    if (approval_by) subQuery += `approval_by=${approval_by}&`;

    return get({
        url: `${URL.uploadManagementV2}/${component}${subQuery ? `?${subQuery}` : ''}`
    }).then(res => {
        return res
    })
}

export function updateUploadInfo(component, reportDate, reportName, status, reason) {
    return put({
        url: `${URL.uploadManagementV2}/${component}`,
        data: {
            report_date: reportDate,
            file_name: reportName,
            status,
            reason
        }
    }).then(res => {
        return res;
    })
}

export function getListReport(component, filename) {
    return get({
        url: `${URL.listReportV2}/${component}/${filename}`
    }).then(res => {
        return res
    })
}

export function deleteListReport(component, objDelete) {
    const { report_date, file_name } = (objDelete || {});
    let subQuery = '';
    if (report_date) subQuery += `report_date=${report_date}&`;
    if (file_name) subQuery += `file_name=${file_name}&`;
    return del({
        url: `${URL.uploadManagementV2}/${component}${subQuery ? `?${subQuery}` : ''}`
    }).then(res => {
        return res
    })
}

export function getListActionLogs(fromDate, toDate, page, limit, searchText) {
    const url = searchText
        ? URL.listActionLogsV2 + `?from_date=${fromDate}&to_date=${toDate}&current_page=${page}&item_count=${limit}&s=${decodeURIComponent(searchText)}`
        : URL.listActionLogsV2 + `?from_date=${fromDate}&to_date=${toDate}&current_page=${page}&item_count=${limit}`
    return get({ url }).then(res => {
        return res
    })
}

export function updateRole(roleInfo) {
    return put({
        url: URL.updateRoleV2,
        data: roleInfo
    }).then(res => {
        return res
    })
}


export function updateMasterTable(listData, masterTableType) {
    return put({
        url: URL.masterTableV2,
        data: {
            list_master_table: listData,
            master_table_type: masterTableType
        }
    }).then(res => {
        return res
    })
}

export function createRole(roleInfo) {
    return post({
        url: URL.createRoleV2,
        data: roleInfo
    }).then(res => {
        return res
    })
}

export function loginWithLdap(username, password) {
    return postCatch({
        url: URL.loginV2,
        data: {
            username: username,
            password: password
        },
        nonToken: true
    }).then(res => {
        if (!res || !res.Success || !res.Data) return { isSuccess: false, error: null }
        saveUserInfo(res)
        return { isSuccess: true, error: null }
    }).catch(err => {
        return { isSuccess: false, error: 'The system is busy. Please try again in a few moments.' }
    });
}

export function login(username, password) {
    return post({
        url: URL.login,
        data: {
            UserName: username,
            Password: password
        },
        nonToken: true
    }).then(res => {
        if (!res || !res.Success || !res.Data) return false
        saveUserInfo(res)
        return true
    })
}

export function queryRoleGroup(isUserRoleGroup = false) {
    return get({
        url: URL.roleListV2
    }).then(res => {
        if (!res || !res.Success || !res.Data) return false
        RoleGroup = [...res.Data]
        if (userInfo && userInfo.RoleGroupId) {
            const roleInfo = RoleGroup.find(item => item.RoleGroupId === userInfo.RoleGroupId) || {
                RoleGroupName: '',
                RoleList: JSON.stringify([])
            };
            setUserRoles(roleInfo.RoleGroupName, JSON.parse(roleInfo.RoleList));
        }
        return true
    })
}

export function getRoleGroup() {
    return [...RoleGroup]
}

export function deleteUser(username) {
    return del({
        url: URL.deleteUserV2 + '/' + username
    }).then(res => {
        return res
    })
}

export function createUser(userInfo) {
    return post({
        url: URL.createUserV2,
        data: userInfo
    }).then(res => {
        return res
    })
}

export function updateUser(userInfo) {
    return put({
        url: URL.updateUserV2,
        data: userInfo
    }).then(res => {
        return res
    })
}

export function getListUser() {
    return get({
        url: URL.listUserV2
    }).then(res => {
        return res
    })
}

export function getMasterTableByType(type) {
    return get({
        url: `${URL.masterTableV2}?master_table_type=${type}`
    }).then(res => {
        return res
    })
}

export function logout() {
    token = null
    userInfo = null
    RoleGroup = null
}

export function getCurrentUserInfo() {
    return { ...userInfo }
}

export function getCapitalPlanningDetails(date) {
    return get({
        url: `${URL.capitalPlanning}?report_date=${date}`
    }).then(res => {
        return res
    })
}

export function downloadCapTemplate() {
    const url = `${URL.capitalPlanning}/sample`;
    const config = {
        headers: { Authorization: "bearer " + token },
        responseType: "arraybuffer"
    }
    return Axios.get(
        url, config
    )
}

function saveUserInfo(resLogin) {
    token = resLogin.Data.AccessToken
    userInfo = resLogin.Data.UserInfo
    renewAccessToken(resLogin.Data.TokenTimeoutMinutes)
}
function renewAccessToken(time) {
    const user = getCurrentUserInfo()
    setTimeout(() => {
        post({
            url: URL.renewTokenV2,
            data: {
                UserName: user.Username
            }
        }).then(res => {
            if (!res || !res.Success || !res.Data) {
                renewAccessToken(time)
            } else {
                token = res.Data
                renewAccessToken(time)
            }
        })
    }, 5 * 60 * 1000);
}

function getWithBlob({ url, nonToken = false }) {
    return new Promise(resolve => {
        const config = {
            responseType: 'blob',
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                }
        }

        Axios.get(
            url, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Get ${url} fail: ${error}`)
            resolve(null)
        });
    })
}

function get({ url, nonToken = false }) {
    return new Promise(resolve => {
        const config = {
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                }
        }

        Axios.get(
            url, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Get ${url} fail: ${error}`)
            resolve(null)
        });
    })
}

function getwithCredentials({ url, nonToken = false }) {
    return new Promise(resolve => {
        const config = {
            headers: nonToken ? null : { Authorization: "bearer " + token },
            withCredentials: true
        }

        Axios.get(
            url, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`GetwithCredentials ${url} fail: ${error}`)
            resolve(null)
        });
    })
}

function post({ url, data, params, nonToken = false, contentType, onUploadProgress, responseType }) {
    return new Promise(resolve => {
        const config = {
            timeout: 300000,
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                }
        }
        if (responseType) {
            config.responseType = responseType;
        }
        if (params) {
            config.params = params;
        }
        if (contentType) {
            if (!config.headers) config.headers = {}
            config.headers['Content-Type'] = contentType
        }
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress
        }

        Axios.post(
            url, data, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Post ${url} fail: ${error}`)
            resolve(null)
        });
    })
}

function postCatch({ url, data, params, nonToken = false, contentType, onUploadProgress }) {
    return new Promise((resolve, reject) => {
        const config = {
            timeout: 60000,
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                }
        }
        if (params) {
            config.params = params;
        }
        if (contentType) {
            if (!config.headers) config.headers = {}
            config.headers['Content-Type'] = contentType
        }
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress
        }

        Axios.post(
            url, data, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Post ${url} fail: ${error}`)
            reject(error)
        });
    })
}

function put({ url, data, nonToken = false }) {
    return new Promise(resolve => {
        const config = {
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                }
        }

        Axios.put(
            url, data, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Put ${url} fail: ${error}`)
            resolve(null)
        });
    })
}

function del({ url, data, nonToken = false }) {
    return new Promise(resolve => {
        const config = {
            headers: nonToken
                ? null
                : {
                    Authorization: "bearer " + token
                },
            data
        }

        Axios.delete(
            url, config
        ).then((response = {}) => {
            if (response.data && response.data.ErrorCode === ErrorCode.JwtExpired) {
                GlobalFunc.logout();
            } else {
                resolve(response.data)
            }
        }).catch((error) => {
            console.error(`Delete ${url} fail: ${error}`)
            resolve(null)
        });
    })
}


// WEBPACK FOOTER //
// ./src/http.js